export const changePurchasePriceReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_PURCHASE_PRICE":
        return action.payload.purchasePrice;
      default:
        return state;
    }
  };
  